import {
  objectOf, arrayOf, shape, string, any, number,
} from 'prop-types';
import productType from './productType';

const categoryDataType = shape({
  categoryId: string.isRequired,
  facets: arrayOf(objectOf(any)),
  name: string,
  navParentCategoryId: string,
  popularSearches: arrayOf(objectOf(any)),
  title: string,
  url: string,
  pagination: shape({
    currentPage: number,
    totalPages: number,
  }),
  productTotalCount: number,
  products: arrayOf(productType),
  espotContent: arrayOf(
    shape({
      espotId: string,
      htmlContent: string,
      timestamp: string,
    }),
  ),
  espotIdentifier: string,
});

export default categoryDataType;
